import React, { useState } from "react";
import "./ProjectPage.css";
import { Link } from "react-router-dom";
import usePageTitle from "../../hooks/useTitlePage";

const ProjectPage = (props) => {
  const [buttonHover, setbuttonHover] = useState(false);
  const [nextButtonHover, setNextButtonHover] = useState(false);
  const [prevButtonHover, setPrevButtonHover] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  usePageTitle(`Featured Projects | ${props.projectTitle} `);

  return (
    <div className="load-square-swipe">
      <div className="IndividualProjectPages">
        <h1 style={{ borderBottom: `5px solid ${props.maincolor}` }}>
          {props.projectTitle}
        </h1>
        <div className="dates_TechStack">
          <div>
            <h2>Tech Stack Used:</h2>
            <ul>
              {props.techstack?.map((item) => {
                return <li>{item}</li>;
              })}
            </ul>
          </div>

          <div>
            <h2>Dates:</h2>
            <ul>
              <li>{props.date}</li>
            </ul>
          </div>

          <div className="Individual-Project-Page-Button">
            <Link to={props.projectLink} target="_blank" rel="noreferrer">
              <div
                className={buttonHover ? "btn sweep-hover" : "btn"}
                style={{
                  cursor: "pointer",
                  border: `2px solid ${props.maincolor}`,
                  "--sweep-color": props.maincolor,
                  "--btn-text": "#fff",
                }}
                onMouseEnter={() => setbuttonHover(true)}
                onMouseLeave={() => setbuttonHover(false)}
              >
                {props.projectLink && <a>More info</a>}
              </div>
            </Link>
          </div>
        </div>

        {/* pulling data from app.js */}
        <div className="pageMap">
          {props.data?.map((item) => {
            if (item.type === "headerImage") {
              return <h1>{item.text}</h1>;
            }
            if (item.type === "paragraph") {
              return <p>{item.text}</p>;
            }
            if (item.type === "list") {
              return (
                <ul>
                  {item.data.map((thing) => {
                    return <li>{thing}</li>;
                  })}
                </ul>
              );
            }
            if (item.type === "listIndex") {
              return <li className="">{item.text}</li>;
            }
            if (item.type === "image") {
              return (
                <img
                  src={item.link}
                  alt={item.alt}
                  onClick={() => {
                    setModalImage(item.link);
                    setOpenModal(true);
                  }}
                  className="clickable-image"
                />
              );
            }
            if (item.type === "header2") {
              return (
                <h2>
                  {item.text}
                  <span style={{ color: props.maincolor }}>.</span>
                </h2>
              );
            }

            if (item.type === "header2Center") {
              return (
                <h2 className="contentH2" style={{ textAlign: "center" }}>
                  {item.text}
                  <span style={{ color: props.maincolor }}>.</span>
                </h2>
              );
            }
            if (item.type === "DoubleImage") {
              return (
                <div className="DoubleImage" style={{ display: "flex" }}>
                  <img
                    src={item.link1}
                    onClick={() => {
                      setModalImage(item.link1);
                      setOpenModal(true);
                    }}
                    className="clickable-image"
                    alt={item.alt}
                  />
                  <img
                    src={item.link2}
                    onClick={() => {
                      setModalImage(item.link2);
                      setOpenModal(true);
                    }}
                    className="clickable-image"
                    alt={item.alt}
                  />
                </div>
              );
            }
            if (item.type === "imageFloatRight") {
              return (
                <img
                  className="imageFloatRight clickable-image"
                  src={item.link}
                  alt={item.alt}
                  onClick={() => {
                    setModalImage(item.link);
                    setOpenModal(true);
                  }}
                />
              );
            }
            if (item.type === "imageFloatLeft") {
              return (
                <img
                  className="imageFloatLeft clickable-image"
                  src={item.link}
                  alt={item.alt}
                  onClick={() => {
                    setModalImage(item.link);
                    setOpenModal(true);
                  }}
                />
              );
            }
            if (item.type === "imageCenter") {
              return (
                <img
                  className="imageCenter clickable-image"
                  src={item.link}
                  alt={item.alt}
                  onClick={() => {
                    setModalImage(item.link);
                    setOpenModal(true);
                  }}
                />
              );
            }
          })}
        </div>

        <div className="route-between-pages">
          <div className="Individual-Project-Page-Button navigation-button">
            <Link to={props.prevPage}>
              <div
                className={prevButtonHover ? " btn sweep-hover" : "btn"}
                style={{
                  cursor: "pointer",
                  border: `2px solid ${props.maincolor}`,
                  "--sweep-color": props.maincolor,
                  "--btn-text": "#fff",
                }}
                onMouseEnter={() => setPrevButtonHover(true)}
                onMouseLeave={() => setPrevButtonHover(false)}
              >
                {props.nextPage && <a>Previous Project</a>}
              </div>
            </Link>
          </div>

          <div className="Individual-Project-Page-Button navigation-button">
            <Link to={props.nextPage}>
              <div
                className={nextButtonHover ? "btn sweep-hover" : "btn"}
                style={{
                  cursor: "pointer",
                  border: `2px solid ${props.maincolor}`,
                  "--sweep-color": props.maincolor,
                  "--btn-text": "#fff",
                }}
                onMouseEnter={() => setNextButtonHover(true)}
                onMouseLeave={() => setNextButtonHover(false)}
              >
                {props.nextPage && (
                  <a href={props.nextPage} rel="noreferrer">
                    Next Project
                  </a>
                )}
              </div>
            </Link>
          </div>
        </div>

        {openModal && (
          <div className="image-modal" onClick={() => setOpenModal(false)}>
            <img
              src={modalImage}
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectPage;
